import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{ @option.label }}",{ moduleName: "garaje/pods/components/announcement-template/announcement-template-selected-item/template.hbs" })